import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="harvest-cycle--form"
// Handles initial-inventory reuse; week selection lives on iso-week-calendar.
export default class extends Controller {
  static targets = ["reuseInventoryButton", "inventoryInput"];
  static values = {
    reuseAvailable: { type: Boolean, default: false },
    reuseBalances: { type: Object, default: {} },
  };

  connect() {
    this.#syncReuseButton();
  }

  spanApplied(event) {
    this.reuseAvailableValue = Boolean(event.detail?.reuseAvailable);
    this.reuseBalancesValue = event.detail?.reuseBalances || {};
    this.#syncReuseButton();
  }

  spanCleared() {
    this.reuseAvailableValue = false;
    this.reuseBalancesValue = {};
    this.#syncReuseButton();
  }

  reusePreviousInventory() {
    if (!this.reuseAvailableValue) return;

    this.inventoryInputTargets.forEach((input) => {
      const cropTypeId = String(input.dataset.cropTypeId || "");
      const value = this.reuseBalancesValue[cropTypeId];
      input.value = value == null ? "0" : String(value);
    });
  }

  #syncReuseButton() {
    if (!this.hasReuseInventoryButtonTarget) return;
    this.reuseInventoryButtonTarget.classList.toggle("hidden", !this.reuseAvailableValue);
  }
}
